"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../core/constants");
var apollo_client_1 = require("apollo-client");
var apollo_link_http_1 = require("apollo-link-http");
var apollo_link_error_1 = require("apollo-link-error");
var apollo_link_context_1 = require("apollo-link-context");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_link_1 = require("apollo-link");
var feedback_message_1 = require("./gql/resolvers/feedback-message");
var httpLink = new apollo_link_http_1.HttpLink({
    uri: constants_1.API_URL + "/graphql",
    credentials: "include",
});
var authLink = apollo_link_context_1.setContext(function (_, _a) {
    var headers = _a.headers;
    return ({
        headers: __assign(__assign({}, headers), { secret: constants_1.API_KEY }),
    });
});
exports.default = new apollo_client_1.ApolloClient({
    link: apollo_link_1.ApolloLink.from([
        apollo_link_error_1.onError(function (_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
            if (graphQLErrors) {
                graphQLErrors.map(function (_a) {
                    var message = _a.message, locations = _a.locations, path = _a.path;
                    return console.error("[GraphQL error]: Message: " + message + ", Location: " + locations + ", Path: " + path);
                });
            }
            if (networkError)
                console.error("[Network error]: " + networkError);
        }),
        authLink.concat(httpLink),
    ]),
    resolvers: {
        Mutation: {
            setFeedbackMessage: feedback_message_1.setFeedbackMessage,
        },
    },
    cache: new apollo_cache_inmemory_1.InMemoryCache(),
});
//# sourceMappingURL=apollo-client.js.map